
// decoradores
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
// helpers
import { log } from "@/helpers/env";
// tipos
import { Permisos } from "@/typings/store/modules/permisos";
import { Item } from "@/typings/components/transporte/flota";
import {
  EstadoVehiculo,
  Vehiculo,
} from "@/typings/store/plugins/easyFirestore/vehiculos";
// componentes
import IconButton from "@/components/custom/IconButton.vue";

@Component({
  components: {
    IconButton,
  },
})
export default class OpcionesTabla extends Vue {
  @Prop() readonly item!: Item;
  @Prop() readonly width?: string | number;
  @Prop() readonly permisos!: Permisos;
  @Prop() readonly seleccionado!: Vehiculo | null;

  cargando = false;

  get isSelected(): boolean {
    return (
      this.seleccionado !== null &&
      this.seleccionado.id === this.item.vehiculo.id
    );
  }

  get mostrarSwitch(): boolean {
    return this.permisos.clientes !== "ver";
  }

  get estado(): EstadoVehiculo {
    const estado = this.item.vehiculo.estado;
    if (!estado) {
      return "habilitado";
    }
    return estado;
  }

  get switchValue(): boolean {
    this.cargando = false;
    return this.estado !== "deshabilitado";
  }

  set switchValue(value: boolean) {
    if (log) {
      console.log("set switchValue", value);
    }
    this.onClickSwitch();
    this.cargando = true;
  }

  @Emit("click:informacion")
  onClickInfo(): Item {
    return this.item;
  }

  @Emit("click:switch")
  onClickSwitch(): Item {
    return this.item;
  }
}
